import slot from "./slot.json";
export default slot;
